import { DimensionAccordionElement } from "./shared";

class SidemenuHandler {
    sidemenuButton: HTMLElement;
    constructor(sidemenuButton: HTMLElement) {
        const sidemenuOverlay = document.getElementById('closemenuoverlay');
        this.sidemenuButton = sidemenuButton;
        this.sidemenuButton.addEventListener('click',() => {
            const sidemenuId = this.sidemenuButton.getAttribute('aria-controls');
            if (sidemenuId) {
                const sidemenu = document.getElementById(sidemenuId);
                const topBar = document.getElementById('topbartablist');
                sidemenu?.classList.toggle('d-none');
                topBar?.classList.toggle('d-none');
            }

            if (this.sidemenuButton.firstElementChild?.classList.contains('display-none')) {
                this.sidemenuButton.firstElementChild?.classList.remove('display-none');
                this.sidemenuButton.lastElementChild?.classList.add('display-none');
                if (!sidemenuOverlay?.classList.contains('display-none')) {
                    sidemenuOverlay?.classList.add('display-none');
                }
            }
            else {
                this.sidemenuButton.firstElementChild?.classList.add('display-none');
                this.sidemenuButton.lastElementChild?.classList.remove('display-none');
                if (sidemenuOverlay?.classList.contains('display-none')) {
                    sidemenuOverlay?.classList.remove('display-none');
                    window.scroll({ top: 0, behavior: 'smooth' });
                }
            }
        });
        sidemenuOverlay?.addEventListener('click', () => {
            this.sidemenuButton.click();
        });
    }
}

class SearchButtonHandler {
    searchBtn: HTMLElement;
    constructor(searchBtn: HTMLElement) {
        this.searchBtn = searchBtn;
        this.searchBtn.addEventListener('click', () => {
            const searchContainerId = this.searchBtn.getAttribute('aria-controls');
            if (searchContainerId) {
                const searchContainer = document.getElementById(searchContainerId);
                searchContainer?.classList.toggle('d-none');
                window.scroll({top: 0,behavior: 'smooth'});
            }
        });
    }
}

const sidemenuButtonDesktop = document.getElementById('sidemenubuttonDesktop');
if (sidemenuButtonDesktop) {
    const sidemenuHandler = new SidemenuHandler(sidemenuButtonDesktop);
}

const sidemenuButtonMobile = document.getElementById('sidemenubuttonMobile');
if (sidemenuButtonMobile) {
    const sidemenuHandler = new SidemenuHandler(sidemenuButtonMobile);
}

const searchBtn = document.getElementById('search-btn');
if (searchBtn) {
    const searchButtonHandler = new SearchButtonHandler(searchBtn);
}

class TabHandler {
    tabListElement: HTMLElement | null;
    sidemenuAccordions?: DimensionAccordionElement[];

    constructor(tabListId: string) {
        this.tabListElement = document.getElementById(tabListId);
        this.registerClickListeners();
        this.updateAccordionListeners();
    }

    getTabs(): HTMLElement[] {
        if (this.tabListElement) {
            return Array.from(this.tabListElement.querySelectorAll('[role="tab"]')) as HTMLElement[];
        }
        return [];
    }

    showTab(tabElementToSelect: HTMLElement) {
        const otherTabs = this.getTabs().filter((tab) => tab !== tabElementToSelect);
        const panelsToHide = otherTabs.map((tab) => this.getPanelFromTabButton(tab));
        const panelToShow = this.getPanelFromTabButton(tabElementToSelect);
        otherTabs.forEach(otherTab => this.setTabSelected(otherTab, false));
        panelsToHide.forEach(panelToHide => panelToHide ? this.setPanelHidden(panelToHide, true) : undefined);
        if (panelToShow) {
            this.setPanelHidden(panelToShow, false);
        }
        this.setTabSelected(tabElementToSelect, true);
        this.updateAccordionListeners();

    }
    updateAccordionListeners() {
        this.sidemenuAccordions?.forEach(accordion => accordion.removeEventListener('accordion-status', this.handleAccordionToggle));
        this.sidemenuAccordions = (Array.from(document.querySelectorAll('.sidebar-tab:not([hidden]) [sidemenu-accordion]')) as DimensionAccordionElement[]);
        this.sidemenuAccordions.forEach(accordion => accordion.addEventListener('accordion-status', this.handleAccordionToggle));
    }

    handleAccordionToggle = (ev: Event) => {
        const customEvent = ev as CustomEvent;
        if (customEvent.detail?.expanded) {
            this.sidemenuAccordions?.forEach(otherAccordion => otherAccordion.id !== customEvent.detail.id ? otherAccordion.expanded = false : undefined);
        }
    };

    setPanelHidden(panel: HTMLElement, hidden: boolean) {
        if (hidden) {
            panel.setAttribute('hidden', '');
            panel.setAttribute('aria-expanded', 'true');
        } else {
            panel.removeAttribute('hidden');
            panel.setAttribute('aria-expanded', 'false');
        }
    }

    setTabSelected(tab: HTMLElement, selected: boolean) {
        tab.setAttribute('aria-selected', '' + selected);
    }

    getPanelFromTabButton(tabElement: HTMLElement) {
        const controlledElementId = tabElement.getAttribute('aria-controls');
        if (controlledElementId) {
            return document.getElementById(controlledElementId);
        }
    }

    registerClickListeners() {
        const tabs = this.getTabs();
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                this.showTab(tab);
            });
        });
    }
}

const tabhandler = new TabHandler('topbartablist');

let waiting = false;
const sidemenuElementDesktop = document.getElementById('sidemenuDesktop');
const sidemenuElementMobile = document.getElementById('sidemenuMobile');
const header = document.getElementById('header');
const body = document.body;

function updateMenuTop() {
    const headerHeight = header?.clientHeight ?? 0;
    const headerOffsetTop = header?.offsetTop ?? 0;
    if (sidemenuElementDesktop) {
        const sidemenuTop = headerHeight - (window.scrollY - headerOffsetTop);
        const margin = parseFloat(window.getComputedStyle(body).marginLeft);
        sidemenuElementDesktop?.setAttribute('style', `top: ${sidemenuTop}px; margin-left: ${margin}px`);
    }
    if (sidemenuElementMobile) {
        const sidemenuTop = headerHeight - (window.scrollY - headerOffsetTop);
        const margin = parseFloat(window.getComputedStyle(body).marginLeft);
        sidemenuElementMobile?.setAttribute('style', `top: ${sidemenuTop}px; margin-left: ${margin}px`);
    }
}

window.requestAnimationFrame(() => {
    updateMenuTop();
});

window.addEventListener('scroll', (e: Event) => {
    if (!waiting) {
        window.requestAnimationFrame(() => {
            waiting = false;
            updateMenuTop();
        });

        waiting = true;
    }
});

window.addEventListener('resize', (e: Event) => {
    if (!waiting) {
        window.requestAnimationFrame(() => {
            waiting = false;
            updateMenuTop();
        });

        waiting = true;
    }
});
